const checkMarkedDependency = (parts, markedDependencies) => {
    for (let i = 0; i < parts.length; i += 1) {
        if (markedDependencies.indexOf(parts[i].uid) > -1) {
            // eslint-disable-next-line no-break
            return true;
        }
    }
    return false;
};

export default checkMarkedDependency;
